import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import { useSession } from '../context/SessionContext.js';
import { Navigate } from 'react-router-dom';
import ReportBugButton from './ReportBugButton.js';
import Seo from './Seo.js';

export default function PrivateLayout() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const { session, loading } = useSession();

  const toggleSidebar = () => setIsSidebarOpen(!isSidebarOpen);

  if (loading) return <div>Loading...</div>;
  if (!session) return <Navigate to="/login" replace />;

  return (
    <>
    {/* <Seo 
        title="Create Free CV & Digital Portfolio" 
        description="Build your professional CV and online portfolio in minutes. 100% free with premium templates and expert guidance."
      /> */}
    <div className="flex">
      {/* Hamburger Button untuk mobile */}
      <button
        onClick={toggleSidebar}
        className="fixed z-40 md:hidden m-4 p-2 shadow-xl text-gray-600 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 rounded-lg"
      >
        <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
        </svg>
      </button>

      <Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} />
      
      <div className={`flex-1 p-6 bg-gray-100 dark:bg-gray-900 transition-margin duration-300`}>
        <Outlet />
      </div>
      <ReportBugButton />
    </div>
    </>
  );
}